function UserNotification(props) {
	return <div className="pt-4 pl-32">{props.item.message}</div>;
}

export default UserNotification;
